<template>
    <section class="recipe-ingredients">
        <h2 class="title" v-test:title>{{ $snippet('you_will_need', 'you will need') }}</h2>
        <ul class="ingredients-list">
            <li
                v-for="(ingredient, i) in ingredients"
                :key="`${ ingredient.name }_${ i }`"
                class="ingredient"
                v-test:ingredientListItem
            >
                <span>{{ ingredient.name }}</span>
                <b-button
                    v-if="ingredient.buttonLink"
                    variant="primary"
                    :to="ingredient.buttonLink"
                    class="get-me-btn"
                    v-test:getMeBtn
                >
                    {{ $snippet('get_me', 'get me') }}
                </b-button>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: 'recipe-ingredients',

        props: {
            ingredients: {
                type: Array,
                required: true,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        font-size: rem(32px);
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;

        @include media-breakpoint-up(lg) {
            text-align: left;
            margin-bottom: 26px;
        }
    }

    .ingredients-list {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
    }

    .ingredient {
        line-height: rem(24px);
        font-size: rem(20px);
        margin-bottom: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @include media-breakpoint-up(md) {
            line-height: rem(20px);
            font-size: rem(16px);
            margin-bottom: 23px;
        }
    }

    .get-me-btn {
        flex-shrink: 0;
        padding: 4px 18px;
        min-width: auto;
        font-size: rem(9px);
        margin-left: 20px;

        @include media-breakpoint-up(md) {
            padding: 3px 18px;
            font-size: rem(16px);
        }
    }
</style>
